/**
 * Author：brand
 * Creation Time：2019-05-14 10:50
 * Email：brandhuang@qq.com
 */
/**
 * 去除字符串中的空格
 */
export function u_delAllSpace(val) {
  return val.replace(/\s/g,"")
}

/**
 * 判断是否为空
 * @param val
 * @returns {boolean}
 */
export function u_isEmpty(val) {
  if(u_delAllSpace(val).length == 0){
    return true
  }else {
    return false
  }
}

/**
 * 手机号校验
 * @param val
 * @returns {boolean}
 */
export function u_checkMobile(val) {
  let regex = "^((13[0-9])|(14[0-9])|(15([0-9]))|(16[0-9])|(17[0-8])|(18[0-9])|(19[0-9]))\\d{8}$";
  let reg = new RegExp(regex)
  if (u_delAllSpace(val).length != 11 || !reg.test(val)) {
    return false;
  } else {
    return true
  }
}

export function u_RenderContent(msg) {
  let data = msg
  let VoiceReg = /((http|https):\/\/)?.*(.mp3)/g
  let VideoReg = /((http|https):\/\/)?.*(.mp4)/g
  let FileReg = /[^.]*(.txt|.pdf|.zip|.doc|.ppt|.docx|.pptx|.xlsx|.xls)((,http|,https):\/\/)?.*(.txt|.pdf|.zip|.doc|.ppt|.docx|.pptx|.xlsx|.xls)/g
  let nbsp = /&nbsp;/ig
  let imgReg1 = /<img(.*?)>/g
  let info = /^{(.*?)}/g
  let tagA = /<\/?a.*?>/ig
  let imgReg2 = /(^(http|https):\/\/)?.*(.jpg|.JPG|.png|.PNG|.gif|.GIF|.JPEG|.jpeg)$/g
  data = data.replace(VoiceReg, (res1, res2) => {
    return '[语音消息]'
  }).replace(VideoReg, (res1, res2) => {
    return '[视频消息]'
  }).replace(FileReg, (res1, res2) => {
    return '[文件消息]'
  }).replace(imgReg1, (res1, res2) => {
    return '[图片]'
  }).replace(imgReg2, (res1, res2) => {
    return '[图片]'
  }).replace(info, (res1, res2) => {
    return '[链接]'
  }).replace(nbsp, (res1, res2) => {
    return ''
  }).replace(tagA, (res1, res2) => { // 去除a标签，保留a标签的内容
    return ''
  })
  return data
}

export function renderUrl (str) {
  let reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
  // return str.replace(reg, "<a href='$1$2' target='_blank'>$1$2</a>")
  let areg = /<a.*?>(.*?)<\/a>/ig
  let imgreg = /<img.*?>/ig
  let aArr = []
  let imgArr = []
  let s = str.replace(imgreg, function (word1, word2) {
    if (str.match(imgreg)) {
      imgArr = str.match(imgreg)
      return '<IMGDONTCHANGE>'
    }
  }).replace(areg, function (word1, word2) {
    if (str.match(areg)) {
      let arr = []
      arr.push('<a href=' + word2 + " target='_blank'>" + word2 + '</a>')
      // aArr = str.match(areg)
      aArr = arr
      return '<ADONTCHANGE>'
    }
  }).replace(reg, function (word1, word2) {
    if (word2) {
      return '<a href=' + word1 + " target='_blank'>" + word1 + '</a>'
    } else {
      return '<a href=http://' + word1 + " target='_blank'>" + word1 + '</a>'
    }
  })

  function set (str, ary, rule) {
    let tmp = str.split(rule)
    let s = ''
    if (tmp.length > 1) {
      for (let i = 0; i < tmp.length; i++) {
        s += tmp[i] + (typeof ary[i] === 'undefined' ? '' : ary[i])
      }
    }
    return s !== '' ? s : str
  }

  let s1 = set(s, aArr, /<ADONTCHANGE>/ig)
  let s2 = set(s1, imgArr, /<IMGDONTCHANGE>/ig)
  return s2
}
//时间戳转日期
export function timestampToTime(timestamp) {
  timestamp = timestamp*1
  var length = timestamp.toString().length
  var date = length==10?new Date(timestamp * 1000):new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0'+ date.getDate(): date.getDate() ) + ' ';
  var h = (date.getHours() < 10 ? '0' +  date.getHours() : date.getHours()) + ':';
  var m = (date.getMinutes() < 10  ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  return Y + M + D + h + m + s;
}

export function utils_RenderMsgLeft(msg){
  let data = msg
  let VoiceReg = /((http|https):\/\/)?.*(.mp3)/g
  let VideoReg = /((http|https):\/\/)?.*(.mp4)/g
  let FileReg = /[^.]*(.txt)((,http|,https):\/\/)?.*(.txt)/g
  let EmojiReg = /:([^:][a-z_\-]+):/g
  let imgReg1 = /<img(.*?)>/g
  let imgReg2 = /(^(http|https):\/\/)?.*(.jpg|.JPG|.png|.PNG|.gif|.GIF|.JPEG|.jpeg)$/g
  let tags = /<.*?>/g
  let nbsp = /&nbsp;/ig
  let tagA = /<\/?a.*?>/ig
  data = data.replace(VoiceReg, (res1, res2) => {
    return '[语音消息]'
  }).replace(VideoReg, (res1, res2) => {
    return '[视频消息]'
  }).replace(FileReg, (res1, res2) => {
    return '[文件消息]'
  }).replace(imgReg1, (res1, res2) => {
    return '[图片]'
  }).replace(imgReg2, (res1, res2) => {
    return '[图片]'
  }).replace(EmojiReg, function(res) {
    for (let key in emoji) {
      let str = ':' + key + ':'
      if (str == res) {
        return '[' + emoji[key][0] + ']'
      }
    }
  }).replace(tagA, (res1, res2) => {
    return ''
  }).replace(nbsp, (res1, res2) => {
    return ''
  }).replace(tags, (res1, res2) => {
    return ''
  })
  return data
}
export function uitls_time_formmat(time) {
  let date = new Date()
  let year = date.getFullYear()
  let day = date.getDate()
  let mouth = date.getMonth() + 1
  if (day < 10) {
    day = '0' + day
  }
  if (mouth < 10) {
    mouth = "0" + mouth
  }
  let today = year + '/' + mouth + '/' + day
  let yesterday
  let reg = new RegExp("-", "g");
  let timeDate = time.split(" ")[0].replace(reg, "/")
  if (today == timeDate) {
    return "今天 " + time.split(" ")[1].substring(0, 5)
  } else {
    return timeDate.substring(2, timeDate.length)
  }
}